export class CredentialsScannedEvent {
  constructor(
    public readonly username: string | null,
    public readonly password: string | null,
    public readonly serialNumber: string | null
  ) {}
}
